import { useFormContext } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { InvitationFormValues } from '@/types/invitation-schema';

type CeremonyKey = 'religious' | 'civil';

interface CeremonyCardProps {
  kind: CeremonyKey;
  title: string;
  description: string;
  placeholderName: string;
  placeholderAddress: string;
}

const CeremonyCard = ({
  kind,
  title,
  description,
  placeholderName,
  placeholderAddress,
}: CeremonyCardProps) => {
  const form = useFormContext<InvitationFormValues>();
  const enabledKey = `${kind}_ceremony_enabled` as const;
  const nameKey = `${kind}_ceremony_name` as const;
  const addressKey = `${kind}_ceremony_address` as const;
  const timeKey = `${kind}_ceremony_time` as const;
  const mapUrlKey = `${kind}_ceremony_map_url` as const;
  const enabled = form.watch(enabledKey);

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <div>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          <FormField
            control={form.control}
            name={enabledKey}
            render={({ field }) => (
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            )}
          />
        </div>
      </CardHeader>
      {enabled && (
        <CardContent className="space-y-4">
          <div className="grid gap-4 md:grid-cols-2">
            <FormField
              control={form.control}
              name={nameKey}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nombre del lugar</FormLabel>
                  <FormControl>
                    <Input placeholder={placeholderName} {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={timeKey}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Hora</FormLabel>
                  <FormControl>
                    <Input type="time" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <FormField
            control={form.control}
            name={addressKey}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Dirección</FormLabel>
                <FormControl>
                  <Input placeholder={placeholderAddress} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name={mapUrlKey}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Link de Google Maps</FormLabel>
                <FormControl>
                  <Input placeholder="https://maps.google.com/..." {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </CardContent>
      )}
    </Card>
  );
};

const CeremoniesTab = () => (
  <div className="grid gap-6">
    <CeremonyCard
      kind="religious"
      title="Ceremonia Religiosa"
      description="Opcional - Iglesia o templo"
      placeholderName="Iglesia de San José"
      placeholderAddress="Calle Principal 123, Ciudad"
    />
    <CeremonyCard
      kind="civil"
      title="Ceremonia Civil"
      description="Opcional - Registro civil o lugar de ceremonia"
      placeholderName="Jardín Botánico"
      placeholderAddress="Av. Central 456, Ciudad"
    />
  </div>
);

export default CeremoniesTab;
